import { apiClient } from "../../utils/apiClient";
import { Parking } from '../../types/parking';

export const fetchParkings = async (): Promise<Parking[]> => {
    return apiClient.get('/parkings').then((response) => response.data);
};

export const upsertParking = async (parking: Parking): Promise<Parking> => {
    return apiClient.post('/parkings/upsertParking', parking).then((response) => response.data);
};

export const getParkingByName = async (parkingName: string): Promise<Parking> => {
    return apiClient.get(`/parkings/name/${parkingName}`).then((response) => response.data);                       
};

